import { gql } from '@apollo/client';

export const UPDATE_GENERIC_ENTITY_FLOW_TRANSITION = gql`
  mutation updateGenericEntityFlowTransition($input: GenericEntityFlowTransitionInput) {
    updateGenericEntityFlowTransition(input: $input) {
      commandId
    }
  }
`;
